import React from "react";

const Loading = () => {
  return (
    <div className="loading_container">
      <p className="text_center">Loading, please wait...</p>
    </div>
  );
};

export default Loading;
